import { useEffect, useState } from "react";
import { getActiveOverlay, type OverlayId } from "@/lib/date-overlays";
import { OVERLAY_COMPONENTS } from "./themes";

const DISPLAY_MS = 30_000;
const FADE_MS = 1500;

export const DateOverlay = () => {
  const [phase, setPhase] = useState<"playing" | "fading" | "done">("playing");

  const activeId: OverlayId | null = getActiveOverlay()?.id ?? null;

  useEffect(() => {
    if (!activeId) {
      setPhase("done");
      return;
    }
    setPhase("playing");
    const fadeTimer = window.setTimeout(() => setPhase("fading"), DISPLAY_MS);
    const doneTimer = window.setTimeout(() => setPhase("done"), DISPLAY_MS + FADE_MS);
    return () => {
      window.clearTimeout(fadeTimer);
      window.clearTimeout(doneTimer);
    };
  }, [activeId]);

  const ThemeComponent = activeId ? OVERLAY_COMPONENTS[activeId] : null;

  if (!ThemeComponent || phase === "done") return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-30 overflow-hidden transition-opacity"
      style={{
        transitionDuration: `${FADE_MS}ms`,
        opacity: phase === "fading" ? 0 : 1,
      }}
      aria-hidden
    >
      <ThemeComponent />
    </div>
  );
};
